// extracted by mini-css-extract-plugin
export default {"badge":"RoleBadge_badge__ff73f","badgeAdmin":"RoleBadge_badgeAdmin__4DHZV","badgeModerator":"RoleBadge_badgeModerator__CtXhK"};